import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/grin': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8C111 8 0 119 0 256S111 504 248 504 496 393 496 256 385 8 248 8zM248 456C137.7 456 48 366.3 48 256S137.7 56 248 56 448 145.7 448 256 358.3 456 248 456zM353.6 304.6C327.7 312.9 289.2 317.7 248 317.7S168.4 312.9 142.4 304.6C132.5 301.5 123 310 124.7 319.9 132.6 367 196 399.9 248 399.9S363.3 367 371.3 319.9C372.9 310.1 363.6 301.5 353.6 304.6zM168 240C185.7 240 200 225.7 200 208S185.7 176 168 176 136 190.3 136 208 150.3 240 168 240zM328 240C345.7 240 360 225.7 360 208S345.7 176 328 176 296 190.3 296 208 310.3 240 328 240z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/grin.js
// module id = S4nX
// module chunks = 144